(function () {
  function init() {
    var root = document.querySelector('[data-rr-header]');
    if (!root) return;

    var overlay = root.querySelector('[data-rr-overlay]');
    var drawer = root.querySelector('[data-rr-drawer]');
    var nav = root.querySelector('.rr-nav');
    var toggles = Array.prototype.slice.call(root.querySelectorAll('[data-rr-panel-toggle]'));
    var closeTimer = null;

    function panelFor(btn) {
      return root.querySelector('[data-rr-panel="' + btn.getAttribute('data-rr-panel-toggle') + '"]');
    }

    function closePanels() {
      toggles.forEach(function (btn) {
        btn.setAttribute('aria-expanded', 'false');
        var panel = panelFor(btn);
        if (panel) panel.hidden = true;
      });
      if (overlay) overlay.hidden = true;
    }

    function openPanel(btn) {
      var panel = panelFor(btn);
      if (!panel) return;
      closePanels();
      btn.setAttribute('aria-expanded', 'true');
      panel.hidden = false;
      if (overlay) overlay.hidden = false;
    }

    function cancelClose() {
      if (closeTimer) {
        clearTimeout(closeTimer);
        closeTimer = null;
      }
    }

    var hoverCapable = window.matchMedia('(hover: hover) and (min-width: 990px)');

    toggles.forEach(function (btn) {
      // Click always works — touch devices, keyboard, and as a toggle on desktop.
      // On hover devices the panel is already open by the time the click lands
      // (mouseenter/focus fire first), so a click there only opens, never closes.
      btn.addEventListener('click', function () {
        if (btn.getAttribute('aria-expanded') === 'true' && !hoverCapable.matches) {
          closePanels();
        } else {
          openPanel(btn);
        }
      });

      btn.addEventListener('mouseenter', function () {
        if (!hoverCapable.matches) return;
        cancelClose();
        openPanel(btn);
      });

      btn.addEventListener('focus', function () {
        if (!hoverCapable.matches) return;
        openPanel(btn);
      });
    });

    // Moving between the nav bar and an open panel stays inside .rr-nav,
    // so the menu only closes once the pointer leaves the whole area.
    if (nav) {
      nav.addEventListener('mouseleave', function () {
        if (!hoverCapable.matches) return;
        cancelClose();
        closeTimer = setTimeout(closePanels, 140);
      });

      nav.addEventListener('mouseenter', cancelClose);
    }

    document.addEventListener('click', function (event) {
      if (!root.contains(event.target)) closePanels();
    });

    if (overlay) overlay.addEventListener('click', closePanels);

    // Mobile drawer
    var openBtn = root.querySelector('[data-rr-drawer-open]');
    var closeBtn = root.querySelector('[data-rr-drawer-close]');

    function openDrawer() {
      if (!drawer) return;
      drawer.hidden = false;
      document.body.style.overflow = 'hidden';
    }

    function closeDrawer() {
      if (!drawer) return;
      drawer.hidden = true;
      document.body.style.overflow = '';
      closeSubs();
    }

    if (openBtn) openBtn.addEventListener('click', openDrawer);
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);

    // Drawer submenus — tapping a row slides one level deeper
    var subPanels = Array.prototype.slice.call(root.querySelectorAll('[data-rr-sub]'));

    function closeSubs() {
      subPanels.forEach(function (panel) {
        panel.hidden = true;
      });
    }

    root.querySelectorAll('[data-rr-sub-open]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var id = btn.getAttribute('data-rr-sub-open');
        closeSubs();
        var panel = root.querySelector('[data-rr-sub="' + id + '"]');
        if (panel) panel.hidden = false;
      });
    });

    root.querySelectorAll('[data-rr-sub-close]').forEach(function (btn) {
      btn.addEventListener('click', closeSubs);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      closePanels();
      closeDrawer();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
